var React = require('react');

function OverlayBack (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M29.7 23.85H18.45v7.208a.2.2 0 0 1-.332.15L7.37 21.75a.2.2 0 0 1 0-.3l10.747-9.458a.2.2 0 0 1 .332.15v7.208H34c.11 0 .2.09.2.2V30.398a.2.2 0 0 1-.2.2h-4.1a.2.2 0 0 1-.2-.2V23.85z","id":"a"})),React.createElement("g",{"transform":"translate(-1258)","fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"transform":"translate(1271 13)","key":0},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("use",{"fill":"#F1F4FC","xlinkHref":"#a","key":1})]),React.createElement("circle",{"stroke":"#B3B1A9","strokeWidth":"4","cx":"1293.5","cy":"35.5","r":"33.5","key":1})])]);
}

OverlayBack.defaultProps = {"width":"71","height":"71"};

module.exports = OverlayBack;

OverlayBack.default = OverlayBack;
